import { updateGlobal, getAPIData, readGlobal } from 'oasis-os-common';
import { InitDataAPIConfig } from '../types';



function performAction(config: InitDataAPIConfig, storeData) {
  switch (config.action) {
    case 'store':
      updateGlobal(config.storeKey, storeData);
  }
}

export const callDataSource = async (apiConfig: InitDataAPIConfig) => {
  const { source, callback, action, asynchronous, storeKey, ...rest } = apiConfig;
  const functionalConfig = readGlobal('$.global.value.functionalConfig');
  const config = { ...rest, functionalConfig };
  if (asynchronous) {
    getAPIData(source, config, {});
  } else {
    const response = await getAPIData(source, config, {});
    if (callback && action) {

      performAction(apiConfig, response);
    }
  }
};
